import React, { Component } from 'react';

class EditPageContent extends Component {

    handleRemovePrint(e) {
        e.preventDefault();
        this.props.callBackRemovePrint(this.props.print)
    }

    componentWillMount() {

    }

    render() {
        return (
            <div className="EditPageContentPrintItem">
                <img src={this.props.print} alt="print" />
                <span
                    className="EditPageContentPrintItem-excluir"
                    onClick={this.handleRemovePrint.bind(this)}
                >
                    <i className="fas fa-times-circle"></i>
                </span>
            </div>
        );

    }
}

export default EditPageContent;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditPageContentPrintItem.js